<script>
import { Helper, debounce } from '@/mixin/helper'
import CreateDomain from './CreateDomain'
import { mapGetters } from 'vuex'
import { getToolsClient } from '@/services/tools'
import moment from 'moment'
import $store from '@/state/store'
import EmailLog from './EmailLog.vue'

moment.locale('id')

const toolsAxios = getToolsClient()
export default {
  props: {
    region: {
      type: String,
      default: 'SG'
    }
  },
  components: {
    CreateDomain,
    EmailLog
  },

  watch: {
    region() {
      this.getCompanies()
    }
  },
  mixins: [Helper],
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      sortBy: 'name',
      sortDesc: false,
      show_model: null,
      filteredItems: [],
      loading: false,
      companies: [],
      modal: false,
      emailLogModal: false,
      isEdit: false,
      detail: null,
    }
  },

  created() {
    this.getCompanies()
  },

  computed: {
    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        const result = this.show_model.map((a) => a.key)
        return this.company.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.company
      }
    },

    company() {
      return [
        {
          key: 'companyName',
          label: this.$t('domain.table.companyName'),
          sortable: true,
        },
        {
          key: 'domainName',
          label: this.$t('domain.table.domainName'),
          sortable: true,
        },
        {
          key: 'offlineTimeout',
          label: this.$t('domain.table.offlineTimeout'),
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'isChild',
          label: this.$t('domain.table.isChild'),
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'isParent',
          label: this.$t('domain.table.isParent'),
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'isWhitelabel',
          label: this.$t('domain.table.isWhitelabel'),
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'createdOn',
          label: this.$t('domain.table.createdOn'),
          sortable: true,
        },
        {
          key: 'updatedOn',
          label: this.$t('domain.table.updatedOn'),
          sortable: true,
        },
        {
          key: 'edit',
          label: this.$t('domain.table.edit'),
          class: 'text-center',
        },
      ]
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
  },
  methods: {
    async getCompanies() {
      this.loading = true

      const payload = {
        page: this.currentPage,
        size: this.perPage,
        q: this.filter,
      }

      const companies = await toolsAxios.get('/company', { 
        params: payload,
        headers: {
          "X-Region": this.region
        }  
      }).catch((error) => {
        this.handleError(error)
      })

      if (!companies.data?.data) return

      this.filteredItems = companies.data.data
      this.totalRows = companies.data.total_count
      this.currentPage = companies.data.page
      this.totalPages = companies.data.total_pages
      this.companies = companies.data.data
      this.loading = false
    },
    hideAddDomainButton() {
      return $store.state.config.hideAddDomainButton
    },
    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data

        if (errorStatus === 400 && errorData.details) {
          errorData.details.forEach((element) => {
            this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
          })
        } else if (errorStatus === 401) {
          this.$toast.error(errorData.error)
          localStorage.removeItem('token')
          localStorage.removeItem('tokenAccess')
          this.$router.push({ name: 'Login' })
        } else if (errorStatus === 403) {
          this.$toast.error(errorData.error)
        } else {
          this.$toast.error(errorData.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },
    changePage(e) {
      this.currentPage = e
      this.getCompanies()
    },

    resetFilter(e) {
      this.currentPage = 1
      this.size = e
      this.getCompanies()
    },

    searchData: debounce(function () {
      this.getCompanies()
    }, 600),

    beforeEdit(data) {
      this.modal = true
      this.detail = data.item
      this.isEdit = true
    },
  },
}
</script>

<style>
@media only screen and (max-width: 400px) {
  #modal-form___BV_modal_outer_ {
    z-index: 2000 !important;
  }
}
</style>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix">
              <!-- Search -->
              <b-button
                v-if="(this.getAccessFunc('') || hasAccess(['sms-md-company:create'])) && !this.hideAddDomainButton()"
                variant="primary"
                @click="modal = true"
                class="me-3 mc-add-domain"
              >
                {{ $t('domain.addDomain') }}
              </b-button>

              <div class="float-end">
                <div class="mc-table-view">
                  <b-button
                    variant="primary"
                    @click="emailLogModal = true"
                    v-if="hasAccess(['email_log:read'])"
                  >
                    {{ $t('domain.customerLog') }}
                  </b-button>
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                    <label class="d-inline-flex align-items-center mc-table-view__search ms-2">
                      <i class="mc-fa fas fa-search"></i>
                      <b-form-input
                        v-model="filter"
                        type="search"
                        :placeholder="$t('global.search') + '...'"
                        class="ms-2"
                        @input="searchData"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table Tracking -->
            <div class="table-responsive my-3 border border-1">
              <b-table
                class="datatables"
                :items="companies"
                :fields="visibleFields"
                show-empty
                :empty-text="$t('global.emptyTable')"
                :empty-filtered-text="$t('global.emptyFilteredTable')"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="loading"
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #cell(isChild)="data">
                  <input
                    class="form-check-input me-1"
                    type="checkbox"
                    v-model="data.item.resellerId"
                    disabled
                  />
                </template>
                <template #cell(isParent)="data">
                  <input
                    class="form-check-input me-1"
                    type="checkbox"
                    v-model="data.item.isParent"
                    disabled
                  />
                </template>
                <template #cell(isWhitelabel)="data">
                  <input
                    class="form-check-input me-1"
                    type="checkbox"
                    v-model="data.item.isWhitelabel"
                    disabled
                  />
                </template>
                <template #cell(createdOn)="data">
                  {{ data.item.createdOn ? momentDMHms(data.value) : '-' }}
                </template>
                <template #cell(updatedOn)="data">
                  {{ data.item.updatedOn ? momentDMHms(data.value) : '-' }}
                </template>
                <template #cell(edit)="data">
                  <!-- add has access here -->
                  <span
                    id="tool-edit"
                    class="icon-fill_edit"
                    v-b-tooltip.hover.top
                    title="Edit Domain"
                    @click="beforeEdit(data)"
                  />
                </template>
              </b-table>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t('show') }}
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      @change="resetFilter"
                    />
                    {{ $t('entry') }}. {{ $t('show') }}&nbsp;<strong>{{
                      filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0
                    }}</strong>
                    &nbsp;{{ $t('to') }}&nbsp;<strong>{{
                      currentPage != totalPages
                        ? currentPage * perPage
                        : (currentPage - 1) * perPage + filteredItems.length
                    }}</strong>
                    &nbsp;{{ $t('from') }}&nbsp;<strong>{{ totalRows }}</strong
                    >&nbsp;{{ $t('entry') }}.
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      @change="changePage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <create-domain
      v-if="modal"
      :modal.sync="modal"
      :is-edit.sync="isEdit"
      :region="region"
      :detail="detail"
      @refetch="changePage(1)"
    />

    <email-log
      v-if="emailLogModal"
      :modal.sync="emailLogModal"
    />
  </div>
</template>
